import React from "react"
import { Link } from "react-router-dom"

export default function footer() {
  return (
    <footer id="footer" className="footer-area">
      <div className="footer-shape shape-1" />
      <div className="footer-shape shape-2" />
      <div className="footer-shape shape-3" />
      <div className="footer-shape shape-4" />
      <div className="footer-shape shape-5" />
      <div className="footer-shape shape-6" />
      <div className="footer-shape shape-7" />
      <div className="footer-shape shape-8" />
      <div className="footer-widget pt-30 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="footer-link d-flex flex-wrap">
                <div
                  className="footer-link-wrapper mt-45 wow fadeIn"
                  data-wow-duration="1.3s"
                  data-wow-delay="0.4s"
                >
                  <div className="footer-title">
                    <h4 className="title">Apps</h4>
                  </div>
                  <ul className="link">
                    <li>
                      <Link to="/faceit-pro-league">FPL CS:GO & Faceit Stats</Link>
                    </li>
                    <li>
                      <Link to="/fastris">FastRIS</Link>
                    </li>
                    <li>
                      <Link to="/ai-image-detection">AI Image Detector</Link>
                    </li>
                    <li>
                      <Link to="/c2pa-ai-detector">C2PA AI Detector</Link>
                    </li>
                    <li>
                      <Link to="/image-search">Image Search</Link>
                    </li>
                    <li>
                      <Link to="/fastingsense">FastingSense</Link>
                    </li>
                    <li>
                      <Link to="/clashtrophy">ClashTrophy</Link>
                    </li>
                    <li>
                      <Link to="/jobyne">Jobyne</Link>
                    </li>
                    <li>
                      <Link to="/AiSmartGallery">AI Smart Gallery</Link>
                    </li>
                    <li>
                      <Link to="/kolay-yemek-tarifleri">Kolay Yemek Tariflerim</Link>
                    </li>
                  </ul>
                </div>
                <div
                  className="footer-link-wrapper mt-45 wow fadeIn"
                  data-wow-duration="1.3s"
                  data-wow-delay="0.6s"
                >
                  <div className="footer-title">
                    <h4 className="title">Support</h4>
                  </div>
                  <ul className="link">
                    <li>
                      <Link to="#">FAQ</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                  </ul>
                </div>{" "}
                {/* footer link wrapper */}
              </div>{" "}
              {/* footer link */}
            </div>
            <div className="col-lg-6 col-md-6">
              <div
                className="footer-contact mt-45 wow fadeIn"
                data-wow-duration="1.3s"
                data-wow-delay="0.8s"
              >
                <div className="footer-title">
                  <h4 className="title">Contact</h4>
                </div>
                <ul className="contact-list">
                  <li>
                    <div className="contact-info d-flex">
                      <div className="info-content media-body">
                        <p className="text">
                          <a href={"mailto:web-developer@outlook.com"}>
                            <i className="lni lni-envelope" />{" "}
                            web-developer@outlook.com
                          </a>
                        </p>
                      </div>
                    </div>{" "}
                    {/* contact info */}
                  </li>
                </ul>{" "}
                {/* contact list */}
              </div>{" "}
              {/* footer contact */}
            </div>
          </div>{" "}
          {/* row */}
        </div>{" "}
        {/* container */}
      </div>{" "}
      {/* footer widget */}
      <div className="footer-copyright">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="copyright d-sm-flex justify-content-between">
                <p>Copyright © 2020 MWX Apps. All rights reserved.</p>
              </div>{" "}
              {/* copyright */}
            </div>
          </div>{" "}
          {/* row */}
        </div>{" "}
        {/* container */}
      </div>{" "}
      {/* footer copyright */}
    </footer>
  )
}
